import { ActionReducerMap, createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromAlarms from './alarms.reducer';
import * as fromRoot from '../../../../reducers';

// feature state
export interface AlarmsState {
  alarms: fromAlarms.State;
}

export interface State extends fromRoot.State {
  alarms: AlarmsState;
}

// reducers
export const reducers: ActionReducerMap<AlarmsState> = {
  alarms: fromAlarms.reducer
};

// ALARMS
export const getState = createFeatureSelector<AlarmsState>('alarms');

export const getAlarmsState = createSelector(
  getState,
  (state: AlarmsState) => state.alarms
);
export const getAlarms = createSelector(
  getAlarmsState,
  fromAlarms.getAll
);
export const getSelectedAlarm = createSelector(
  getAlarmsState,
  fromAlarms.getSelected
);
export const getAlarmsLoading = createSelector(
  getAlarmsState,
  fromAlarms.getLoading
);
export const getAlarmsLoaded = createSelector(
  getAlarmsState,
  fromAlarms.getLoaded
);
export const getAlarmRemoved = createSelector(
  getAlarmsState,
  fromAlarms.getAlarmRemoved
);
export const getBulkAlarmRemoved = createSelector(
  getAlarmsState,
  fromAlarms.getBulkAlarmRemoved
);
export const getBulkAlarmInactivated = createSelector(
  getAlarmsState,
  fromAlarms.getBulkAlarmInactivated
);
export const getBulkAlarmActivated = createSelector(
  getAlarmsState,
  fromAlarms.getBulkAlarmActivated
);
export const getBulkUpdateNotificationChannel = createSelector(
  getAlarmsState,
  fromAlarms.getBulkUpdateNotificationChannel
);
export const getSelectedMeteringPoints = createSelector(
  getAlarmsState,
  fromAlarms.getSelectedMeteringPoints
);
// Alarms Filter
export const getAlarmsFilterSettings = createSelector(
  getAlarmsState,
  fromAlarms.getAlarmsFilterSettings
);
